/**
 * Thrown by {@link AuthInterceptor} when an auth-required request cannot be sent
 * because there is no valid session (expired token, logout in progress).
 *
 * The interceptor errors with this instead of completing silently so downstream
 * consumers (`rxResource`, `forkJoin`, `firstValueFrom`, …) fail predictably
 * rather than completing without a value. It is intentionally suppressed by
 * `LogService` so logout-triggered request aborts are not reported to Sentry.
 */
export class AuthRequiredError extends Error {
  constructor(reason = 'AuthInterceptorAuthRequired') {
    super(`Request aborted: no valid session (${reason})`);
    this.name = 'AuthRequiredError';
  }
}
